import { render, staticRenderFns } from "./about-main.vue?vue&type=template&id=ea0f0d64"
import script from "./about-main.vue?vue&type=script&lang=js"
export * from "./about-main.vue?vue&type=script&lang=js"
import style0 from "./about-main.vue?vue&type=style&index=0&id=ea0f0d64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports